const serverUrl = "https://v1-dot-sinuous-transit-415706.el.r.appspot.com";
// const serverUrl = "http://127.0.0.1:8000";
export { serverUrl };
